let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kf69x")).then(() => parcelRequire('i2pAY'));